// src/features/records/components/ShareDialog/components/NotifyToggle.js

import React from 'react';
import { Bell } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './NotifyToggle.module.css';

const NotifyToggle = ({
  notifyUsers = true,
  onNotifyChange,
  disabled = false,
  className = '',
}) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!disabled) onNotifyChange(!notifyUsers);
  };
  
  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault();
      onNotifyChange(!notifyUsers);
    }
  };

  return (
    <div
      className={`${styles.toggleContainer} ${disabled ? styles.disabled : ''} ${className}`}
      onClick={handleClick}
    >
      <div
        className={styles.toggleSwitch}
        role="switch"
        aria-checked={notifyUsers}
        tabIndex={disabled ? -1 : 0}
        onKeyDown={handleKeyDown}
        aria-label={t("records.share.notify.label", "Notify people")}
      >
        <div className={`${styles.toggleTrack} ${notifyUsers ? styles.checked : ''}`} />
        <div className={`${styles.toggleKnob} ${notifyUsers ? styles.checked : ''}`} />
      </div>
      <label className={styles.toggleLabel}>
        <Bell size={16} className={styles.icon} />
        <span className={styles.labelFull}>
          {t("records.share.notify.label", "Notify people")}
        </span>
        <span className={styles.labelShort}>
          {t("records.share.notify.short_label", "Notify")}
        </span>
        {/* <320px: icon only (both spans hidden via CSS) */}
      </label>
    </div>
  );
};

export default NotifyToggle;
